import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, useLocalizeMessage } from 'libs.nucleus';
import { useLumosAuth } from '../../../hooks/use_lumos_auth';
const PIOversightSummaryFooter = ({ onReviewAndSignClick }) => {
    const translate = useLocalizeMessage();
    const { isSiteInvestigator } = useLumosAuth();
    if (!isSiteInvestigator) {
        return (_jsx("div", { className: 'mt-4 p-4 bg-yellow-50 border-l-4 border-yellow-600 rounded-md', children: _jsxs("div", { children: [_jsx("h3", { className: 'text-sm font-medium text-yellow-900', children: translate('generic.action_required') }), _jsx("p", { className: 'mt-1 text-sm text-yellow-900', children: translate('label.pi_oversight.action_required_message') })] }) }));
    }
    return (_jsx(Button, { variant: 'secondary', size: 'sm', label: translate('action.pi_oversight.review_and_sign'), onClick: onReviewAndSignClick, iconName: 'arrowUpRight', iconPosition: 'end', className: 'mt-4', "data-testid": 'review-and-sign-button' }));
};
export default PIOversightSummaryFooter;
